import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderDraftResponse,
  IInventoryPurchaseOrderPoId,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const usePOCreateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const { enable, disable } = useLoaderActions("isPOCreateInProgress");
  const execute = useCallback(
    async (filterProps?: null) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IInventoryPurchaseOrderPoId = await axios
          .post(INVENTORY_MODULE?.PURCHASE_ORDER_PO_ID_CREATE?.baseURL ?? "", filterProps, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseOrderDraftResponse>) => {
            disable();
            if (res.data.status === true) {
              return res.data.data;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            disable();
            captureError(e)
            return null;
          });
        return response;
      } catch (e: any) {
        disable();
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
